import Typography from 'typography';
import bootstrap from 'typography-theme-bootstrap';
import fairyGates from 'typography-theme-fairy-gates';
import moraga from 'typography-theme-moraga';
import alton from 'typography-theme-alton';
import funston from 'typography-theme-funston';
import { MOBILE_MEDIA_QUERY } from 'typography-breakpoint-constants';

// Bootstrap typography overrides
bootstrap.overrideThemeStyles = ({ adjustFontSizeTo, rhythm }) => ({
  'h1,h2,h3,h4,h5,h6': {
    lineHeight: '1.1'
  },
  li: {
    marginBottom: 0
  },
  blockquote: {
    borderLeft: `${rhythm(1 / 6)} solid`
  },
  h6: {
    ...adjustFontSizeTo('1.2rem'),
    fontFamily: 'initial'
  },
  [MOBILE_MEDIA_QUERY]: {
    h1: {
      ...adjustFontSizeTo('24px')
    }
  }
});
bootstrap.headerFontFamily = [
  'Avenir Next',
  'Helvetica Neue',
  'Segoe UI',
  'Helvetica',
  'Arial',
  'sans-serif'
];
bootstrap.headerColor = 'inherit';
bootstrap.bodyColor = 'inherit';

// FairyGates typography overrides
fairyGates.overrideThemeStyles = ({ adjustFontSizeTo, rhythm }) => ({
  a: {
    color: 'inherit',
    textShadow: 'none',
    backgroundImage: 'none'
  },
  li: {
    marginBottom: 0
  },
  blockquote: {
    borderLeft: `${rhythm(6 / 16)} solid`
  },
  'h1,h2,h3,h4,h5,h6': {
    marginTop: rhythm(0),
    color: 'inherit'
  },
  h6: {
    ...adjustFontSizeTo('1.2rem'),
    fontFamily: 'Quattrocento Sans'
  },
  [MOBILE_MEDIA_QUERY]: {
    blockquote: {
      borderLeft: `${rhythm(3 / 16)} solid`
    },
    h1: {
      ...adjustFontSizeTo('24px')
    },
    'h1,h2,h3,h4,h5,h6': {
      marginTop: rhythm(0)
    }
  }
});
fairyGates.headerColor = 'inherit';
fairyGates.bodyColor = 'inherit';

// Moraga typography overrides
moraga.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  a: {
    color: 'inherit'
  },
  li: {
    marginBottom: 0
  },
  'a:hover': {
    color: 'inherit',
    textDecoration: 'inherit'
  },
  h6: {
    ...adjustFontSizeTo('1.2rem'),
    fontFamily: 'Source Sans Pro'
  },
  [MOBILE_MEDIA_QUERY]: {
    h1: {
      ...adjustFontSizeTo('24px')
    }
  }
});
moraga.headerColor = 'inherit';
moraga.bodyColor = 'inherit';

// Alton typography overrides
alton.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  a: {
    color: 'inherit'
  },
  li: {
    marginBottom: 0
  },
  'a:hover,a:active': {
    color: 'inherit',
    textDecoration: 'inherit'
  },
  h6: {
    ...adjustFontSizeTo('1.2rem'),
    fontFamily: 'Open Sans'
  }
});
alton.bodyColor = 'inherit';

// Funston typography overrides
funston.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  a: {
    color: 'inherit'
  },
  li: {
    marginBottom: 0
  },
  'a:hover': {
    color: 'inherit',
    textDecoration: 'inherit'
  },
  h6: {
    ...adjustFontSizeTo('1.2rem'),
    fontFamily: 'Cabin Condensed'
  },
  [MOBILE_MEDIA_QUERY]: {
    h1: {
      ...adjustFontSizeTo('28px')
    }
  }
});
funston.bodyColor = 'inherit';
funston.bodyFontFamily = ['Alegreya', 'serif'];
funston.headerFontFamily = ['Cardo', 'serif'];

// montserrat typography overrides
const montserrat = {
  googleFonts: [
    {
      name: 'Montserrat',
      styles: ['400']
    },
    {
      name: 'Playfair Display',
      styles: ['300i']
    }
  ],
  title: 'fontTitle',
  baseFontSize: '16px'
};

montserrat.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  blockquote: {
    ...adjustFontSizeTo('19px'),
    fontStyle: 'italic',
    fontFamily: 'Playfair Display serif'
  },
  h1: {
    fontSize: '2.3rem',
    lineHeight: '2.5rem'
  },
  h2: {
    fontSize: '1.7rem',
    lineHeight: '2rem'
  },
  h3: {
    fontSize: '1.2rem',
    lineHeight: '1.4rem'
  },
  h6: {
    ...adjustFontSizeTo('1.2rem'),
    fontFamily: 'Montserrat'
  },
  p: {
    fontWeight: '400'
  },
  'blockquote > :last-child': {
    marginBottom: 0
  },
  [MOBILE_MEDIA_QUERY]: {
    h1: {
      ...adjustFontSizeTo('28px')
    }
  }
});
montserrat.bodyColor = 'inherit';
montserrat.bodyFontFamily = ['Montserrat', 'sans-serif'];
montserrat.headerFontFamily = ['Montserrat', 'sans-serif'];

const roboto = {
  googleFonts: [
    {
      name: 'Roboto Slab',
      styles: ['700', '400', '300']
    },
    {
      name: 'Roboto',
      styles: ['700', '300']
    }
  ],
  title: 'roboto',
  baseFontSize: '16px'
};

roboto.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  blockquote: {
    ...adjustFontSizeTo('19px'),
    fontStyle: 'italic'
  },
  h1: {
    fontFamily: 'Roboto Slab'
  },
  'h2,h3,h4,h5': {
    fontFamily: 'Roboto',
    fontWeight: '700'
  },
  h6: {
    ...adjustFontSizeTo('21.1167px'),
    fontFamily: 'Roboto'
  },
  p: {
    fontWeight: '300'
  },
  'blockquote > :last-child': {
    marginBottom: 0
  },
  [MOBILE_MEDIA_QUERY]: {
    h1: {
      ...adjustFontSizeTo('28px')
    }
  }
});
roboto.bodyColor = 'inherit';
roboto.bodyFontFamily = ['Roboto', 'sans-serif'];
roboto.headerFontFamily = ['Roboto Slab', 'sans-serif'];

const m3medical = {
  googleFonts: [
    {
      name: 'EB Garamond',
      styles: ['600', '400']
    }
  ],
  title: 'eb garamond',
  baseFontSize: '16px'
};

m3medical.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  h6: {
    ...adjustFontSizeTo('21.1167px'),
    fontFamily: 'sans-serif'
  }
});

m3medical.bodyColor = 'inherit';
m3medical.bodyFontFamily = [
  'Avenir Next',
  'Helvetica Neue',
  'Segoe UI',
  'Helvetica',
  'Arial',
  'sans-serif'
];
m3medical.headerFontFamily = ['EB Garamond', 'serif'];

const EBGaramondAndRoboto = {
  googleFonts: [
    {
      name: 'EB Garamond',
      styles: ['600', '300']
    },
    {
      name: 'Roboto',
      styles: ['500']
    }
  ],
  title: 'Garamond and Roboto',
  baseFontSize: '16px'
};

EBGaramondAndRoboto.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  blockquote: {
    ...adjustFontSizeTo('19px'),
    fontStyle: 'italic'
  },
  h1: {
    fontFamily: 'EB Garamond, Serif'
  },
  'h2,h3,h4,h5': {
    fontFamily: 'EB Garamond, Serif',
    fontWeight: '500'
  },
  h6: {
    ...adjustFontSizeTo('21.1167px'),
    fontFamily: 'Roboto, sans-serif'
  },
  p: {
    fontWeight: '300'
  },
  'blockquote > :last-child': {
    marginBottom: 0
  },
  [MOBILE_MEDIA_QUERY]: {
    h1: {
      ...adjustFontSizeTo('28px')
    }
  }
});
EBGaramondAndRoboto.bodyColor = 'inherit';
EBGaramondAndRoboto.bodyFontFamily = ['Roboto', 'sans-serif'];
EBGaramondAndRoboto.headerFontFamily = ['EB Garamond', 'serif'];

const ArchivoAndPlayfairDisplay = {
  googleFonts: [
    {
      name: 'Archivo',
      styles: ['600', '300']
    },
    {
      name: 'Playfair Display',
      styles: ['500']
    }
  ],
  title: 'Archivo and Playfair Display',
  baseFontSize: '16px'
};

ArchivoAndPlayfairDisplay.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  blockquote: {
    fontSize: '1.125rem',
    lineHeight: '1.25rem',
    fontStyle: 'italic',
    fontFamily: 'Playfair Display, serif'
  },
  'h1, h1 p,h1 a,h1 span,h1 div': {
    fontSize: '2.5625rem',
    lineHeight: '2.7625rem'
  },
  'h2, h2 p,h2 a,h2 span,h2 div': {
    fontSize: '1.9375rem',
    lineHeight: '2.1375rem'
  },
  'h3, h3 p,h3 a,h3 span,h3 div': {
    fontSize: '1.5625rem',
    lineHeight: '1.7625rem'
  },
  'h4, h4 p,h4 a,h4 span,h4 div': {
    fontSize: '1.1875rem',
    lineHeight: '1.375rem'
  },
  'h5, h5 p,h5 a,h5 span,h5 div': {
    fontSize: '0.9375rem',
    lineHeight: '1.125rem'
  },
  'h6, h6 p,h6 a,h6 span,h6 div': {
    fontSize: '1.3125rem',
    lineHeight: '1.5rem'
  },
  a: {
    fontSize: '0.9375rem',
    lineHeight: '1.125rem',
    fontFamily: 'Archivo, sans-serif'
  },
  'p, span, b, ul, li, div, button, input': {
    fontSize: '0.9375rem',
    lineHeight: '1.125rem',
    fontFamily: 'Archivo, sans-serif'
  },
  'blockquote > :last-child': {
    marginBottom: 0
  },
  [MOBILE_MEDIA_QUERY]: {
    'h1, h1 p,h1 a,h1 span,h1 div': {
      ...adjustFontSizeTo('28px')
    },
    'h2, h2 p,h2 a,h2 span,h2 div': {
      ...adjustFontSizeTo('25px')
    },
    'h3, h3 p,h3 a,h3 span,h3 div': {
      ...adjustFontSizeTo('22px')
    },
    'h4, h4 p,h4 a,h4 span,h4 div': {
      ...adjustFontSizeTo('20px')
    },
    'h5, h5 p,h5 a,h5 span,h5 div': {
      ...adjustFontSizeTo('18px')
    },
    'h6, h6 p,h6 a,h6 span,h6 div': {
      ...adjustFontSizeTo('22px')
    }
  }
});

ArchivoAndPlayfairDisplay.bodyColor = 'inherit';
ArchivoAndPlayfairDisplay.bodyFontFamily = ['Archivo', 'sans-serif'];
ArchivoAndPlayfairDisplay.headerFontFamily = ['Archivo', 'sans-serif'];

const robotoAndYanoneKaffeesatz = {
  googleFonts: [
    {
      name: 'Roboto Slab',
      styles: ['700', '400', '300']
    },
    {
      name: 'Roboto',
      styles: ['700', '400']
    },
    {
      name: 'Yanone Kaffeesatz',
      styles: ['400']
    }
  ],
  title: 'roboto and yanone',
  baseFontSize: '16px'
};

robotoAndYanoneKaffeesatz.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  blockquote: {
    ...adjustFontSizeTo('19px'),
    fontStyle: 'italic',
    color: '#004770'
  },
  h1: {
    fontFamily: 'Yanone Kaffeesatz',
    fontSize: '48px',
    fontWeight: '400',
    marginBottom: '1rem'
  },
  'h1,h2,h3': {
    color: '#004770'
  },
  'h2,h3,h4,h5,h6': {
    fontFamily: 'Roboto Slab',
    fontWeight: '400',
    color: '#666666',
    marginBottom: '1rem'
  },
  p: {
    fontWeight: '300',
    color: '#333',
    marginBottom: '1rem'
  },
  'blockquote > :last-child': {
    marginBottom: 0
  },
  'blockquote p': {
    color: '#004770'
  },
  [MOBILE_MEDIA_QUERY]: {
    h1: {
      ...adjustFontSizeTo('18px')
    }
  }
});
robotoAndYanoneKaffeesatz.bodyColor = 'inherit';
robotoAndYanoneKaffeesatz.bodyFontFamily = ['Roboto', 'sans-serif'];
robotoAndYanoneKaffeesatz.headerFontFamily = ['Roboto Slab', 'sans-serif'];

// ECCMID 2019
const EncodeSansAndPlayFairDisplay = {
  googleFonts: [
    {
      name: 'Encode Sans',
      styles: ['600', '300']
    },
    {
      name: 'Playfair Display',
      styles: ['500']
    }
  ],
  title: 'Encode Sans and Playfair Display',
  baseFontSize: '17px'
};

EncodeSansAndPlayFairDisplay.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  blockquote: {
    fontSize: '1.125rem',
    lineHeight: '1.25rem',
    fontStyle: 'italic',
    fontFamily: 'Playfair Display, serif'
  },
  'h1, h1 p,h1 a,h1 span,h1 div': {
    fontSize: '2rem',
    lineHeight: '2.2rem'
  },
  'h2, h2 p,h2 a,h2 span,h2 div': {
    fontSize: '2rem',
    lineHeight: '2.2rem'
  },
  'h3, h3 p,h3 a,h3 span,h3 div': {
    fontSize: '1.5rem',
    lineHeight: '1.7rem'
  },
  'h4, h4 p,h4 a,h4 span,h4 div': {
    fontSize: '1.1875rem',
    lineHeight: '1.375rem'
  },
  'h5, h5 p,h5 a,h5 span,h5 div': {
    fontSize: '0.9375rem',
    lineHeight: '1.125rem'
  },
  'h6, h6 p,h6 a,h6 span,h6 div': {
    fontSize: '1.2rem',
    lineHeight: '1.5rem'
  },
  a: {
    fontSize: '1rem',
    lineHeight: '1.15rem',
    fontFamily: 'Encode Sans, sans-serif'
  },
  'p, span, b, ul, li, div, button, input': {
    fontSize: '1rem',
    lineHeight: '1.15rem',
    fontFamily: 'Encode Sans, sans-serif'
  },
  'blockquote > :last-child': {
    marginBottom: 0
  },
  [MOBILE_MEDIA_QUERY]: {
    'h1, h1 p,h1 a,h1 span,h1 div': {
      ...adjustFontSizeTo('1.6rem')
    },
    'h2, h2 p,h2 a,h2 span,h2 div': {
      ...adjustFontSizeTo('1.6rem')
    },
    'h3, h3 p,h3 a,h3 span,h3 div': {
      ...adjustFontSizeTo('1.2rem')
    },
    'h4, h4 p,h4 a,h4 span,h4 div': {
      ...adjustFontSizeTo('20px')
    },
    'h5, h5 p,h5 a,h5 span,h5 div': {
      ...adjustFontSizeTo('18px')
    },
    'h6, h6 p,h6 a,h6 span,h6 div': {
      ...adjustFontSizeTo('1rem')
    }
  }
});

EncodeSansAndPlayFairDisplay.bodyColor = 'inherit';
EncodeSansAndPlayFairDisplay.bodyFontFamily = ['Encode Sans', 'sans-serif'];
EncodeSansAndPlayFairDisplay.headerFontFamily = ['Encode Sans', 'sans-serif'];

// ISTH 2019
const openSans = {
  googleFonts: [
    {
      name: 'Open Sans',
      styles: ['600', '300']
    }
  ],
  title: 'Open Sans',
  baseFontSize: '16px'
};

openSans.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  blockquote: {
    fontSize: '1.125rem',
    lineHeight: '1.25rem',
    fontStyle: 'italic'
  },
  'h1, h1 p,h1 a,h1 span,h1 div': {
    fontSize: '2.9375rem',
    lineHeight: '3.1rem'
  },
  'h2, h2 p,h2 a,h2 span,h2 div': {
    fontSize: '1.4375rem',
    lineHeight: '1.7375rem'
  },
  'h3, h3 p,h3 a,h3 span,h3 div': {
    fontSize: '1.5rem',
    lineHeight: '1.7rem'
  },
  'h4, h4 p,h4 a,h4 span,h4 div': {
    fontSize: '1.4375rem',
    lineHeight: '1.865rem'
  },
  'h5, h5 p,h5 a,h5 span,h5 div': {
    fontSize: '1.1875rem',
    lineHeight: '1.3rem'
  },
  'h6, h6 p,h6 a,h6 span,h6 div': {
    fontSize: '1.2rem',
    lineHeight: '1.5rem'
  },
  a: {
    fontSize: '0.9375rem',
    lineHeight: '1.1rem',
    fontFamily: 'Encode Sans, sans-serif'
  },
  'p, span, b, ul, li, div, button, input': {
    fontSize: '1rem',
    lineHeight: '1.15rem',
    fontFamily: 'Encode Sans, sans-serif'
  },
  'blockquote > :last-child': {
    fontSize: '1.1875rem',
    marginBottom: 0
  },
  [MOBILE_MEDIA_QUERY]: {
    'h1, h1 p,h1 a,h1 span,h1 div': {
      ...adjustFontSizeTo('1.6rem')
    },
    'h2, h2 p,h2 a,h2 span,h2 div': {
      ...adjustFontSizeTo('1.6rem')
    },
    'h3, h3 p,h3 a,h3 span,h3 div': {
      ...adjustFontSizeTo('1.2rem')
    },
    'h4, h4 p,h4 a,h4 span,h4 div': {
      ...adjustFontSizeTo('20px')
    },
    'h5, h5 p,h5 a,h5 span,h5 div': {
      ...adjustFontSizeTo('18px')
    },
    'h6, h6 p,h6 a,h6 span,h6 div': {
      ...adjustFontSizeTo('1rem')
    }
  }
});

openSans.bodyColor = 'inherit';
openSans.bodyFontFamily = ['Open Sans', 'sans-serif'];
openSans.headerFontFamily = ['Open Sans', 'sans-serif'];

const openSansAndPlayfairDisplay = {
  googleFonts: [
    {
      name: 'Open Sans',
      styles: ['600', '300']
    },
    {
      name: 'Playfair Display',
      styles: ['500']
    }
  ],
  title: 'Open Sans',
  baseFontSize: '16px'
};

openSansAndPlayfairDisplay.overrideThemeStyles = ({ adjustFontSizeTo }) => ({
  blockquote: {
    fontSize: '1.1875rem',
    lineHeight: '1.25rem',
    fontStyle: 'italic'
  },
  'h1, h1 p,h1 a,h1 span,h1 div': {
    fontSize: '1.9375rem',
    lineHeight: '3.1rem'
  },
  'h2, h2 p,h2 a,h2 span,h2 div': {
    fontSize: '1.6875rem',
    lineHeight: '1.7375rem'
  },
  'h3, h3 p,h3 a,h3 span,h3 div': {
    fontSize: '1.5rem',
    lineHeight: '1.7rem'
  },
  'h4, h4 p,h4 a,h4 span,h4 div': {
    fontSize: '1.4375rem',
    lineHeight: '1.865rem'
  },
  'h5, h5 p,h5 a,h5 span,h5 div': {
    fontSize: '1.1875rem',
    lineHeight: '1.3rem'
  },
  'h6, h6 p,h6 a,h6 span,h6 div': {
    fontSize: '1.2rem',
    lineHeight: '1.5rem'
  },
  a: {
    fontSize: '0.9375rem',
    lineHeight: '1.1rem',
    fontFamily: 'Encode Sans, sans-serif'
  },
  'p, span, b, ul, li, div, button, input': {
    fontSize: '1rem',
    lineHeight: '1.15rem',
    fontFamily: 'Encode Sans, sans-serif'
  },
  'blockquote > :last-child': {
    fontSize: '1.1875rem',
    marginBottom: 0
  },
  [MOBILE_MEDIA_QUERY]: {
    'h1, h1 p,h1 a,h1 span,h1 div': {
      ...adjustFontSizeTo('1.6rem')
    },
    'h2, h2 p,h2 a,h2 span,h2 div': {
      ...adjustFontSizeTo('1.6rem')
    },
    'h3, h3 p,h3 a,h3 span,h3 div': {
      ...adjustFontSizeTo('1.2rem')
    },
    'h4, h4 p,h4 a,h4 span,h4 div': {
      ...adjustFontSizeTo('20px')
    },
    'h5, h5 p,h5 a,h5 span,h5 div': {
      ...adjustFontSizeTo('18px')
    },
    'h6, h6 p,h6 a,h6 span,h6 div': {
      ...adjustFontSizeTo('1rem')
    }
  }
});

openSansAndPlayfairDisplay.bodyColor = 'inherit';
openSansAndPlayfairDisplay.bodyFontFamily = ['Open Sans', 'sans-serif'];
openSansAndPlayfairDisplay.headerFontFamily = ['Playfair Display'];

export const bootstrapTheme = new Typography(bootstrap);
export const openSansTheme = new Typography(openSans);
export const fairyGatesTheme = new Typography(fairyGates);
export const moragaTheme = new Typography(moraga);
export const altonTheme = new Typography(alton);
export const funstonTheme = new Typography(funston);
export const montserratTheme = new Typography(montserrat);
export const robotoTheme = new Typography(roboto);
export const m3medicalTheme = new Typography(m3medical);
export const EBGaramondAndRobotoTheme = new Typography(EBGaramondAndRoboto);
export const ArchivoAndPlayfairDisplayTheme = new Typography(
  ArchivoAndPlayfairDisplay
);
export const EncodeSansAndPlayFairDisplayTheme = new Typography(
  EncodeSansAndPlayFairDisplay
);
export const robotoAndYanoneKaffeesatzTheme = new Typography(
  robotoAndYanoneKaffeesatz
);
export const openSansAndPlayfairDisplayTheme = new Typography(
  openSansAndPlayfairDisplay
);
